<template>
  <a-space direction="vertical" :style="{ width: '100%' }" :size="[0, 48]">
    <a-layout>
      <NavHeader />
      <a-layout  :style="styles">
        <router-view></router-view>
      </a-layout>
      <BottomFooter />
    </a-layout>
  </a-space>  
</template>

<script setup>
import NavHeader from './header'
import BottomFooter from '../components/bottomFooter'

const styles = {
  backgroundColor: '#fff',
};
</script>
